import { Spin } from "antd";
import { API } from "api";
import { errorHandler } from "api/api/errorHandler";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MenuAction } from "redux/actions";
import { LoaderAction } from "redux/actions";
import { UTILS } from "utils";
import { useTranslation } from "react-i18next";
import { CloudUploadOutlined } from "@material-ui/icons";
import AppModal from "components/ui/AppModal";
import AppButton from "components/ui/AppButton";

function BulkMenu({ open, setOpen }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const { isLoading } = useSelector((state) => state.LoaderReducer);
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(null);

  const handleClose = () => {
    setOpen(false);
    setError(null);
    setFile(null);
    if (fileInputRef?.current) {
      fileInputRef.current.value = "";
    }
  };
  const uploadFile = async (e) => {
    e.preventDefault();
    setError(null);
    if (!file) {
      UTILS.errorNotification(t("Please select a file"));
      return;
    }
    if (
      file.type !==
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      setError(t("Please select a valid excel file"));
      return;
    }
    dispatch(LoaderAction.setLoading(true));
    const userDetail = UTILS.getCurrentUser();
    try {
      var formData = new FormData();
      formData.append("file", file);
      formData.append("brandId", userDetail.brandId);
      const res = await API.uploadBulkItems(formData);
      if (res?.success === 1) {
        UTILS.successNotification(res?.message);
        dispatch(MenuAction.syncData());
        handleClose();
      } else {
        setError(errorHandler(res?.message));
      }
    } catch (err) {
      setError(errorHandler(err));
    } finally {
      setFile(null);
      if (fileInputRef?.current) {
        fileInputRef.current.value = "";
      }
      dispatch(LoaderAction.setLoading(false));
    }
  };

  const footer = (
    <div className="flex justify-end gap-3">
      <AppButton
        type="button"
        variant="outline"
        onClick={handleClose}
        disabled={isLoading}
      >
        {t("Cancel")}
      </AppButton>
      <AppButton
        type="submit"
        form="bulk-menu-upload-form"
        loading={isLoading}
        disabled={isLoading}
      >
        {t("Submit")}
      </AppButton>
    </div>
  );

  return (
    <AppModal
      title={t("Upload Bulk Items")}
      open={open}
      onClose={handleClose}
      width={560}
      className="app-modal bulk-menu-modal"
      bodyStyle={{ padding: "12px 24px" }}
      footer={footer}
    >
      {error && (
        <div className="m-2 rounded bg-red-500 p-2 text-center text-white">
          <p dangerouslySetInnerHTML={{ __html: error }}></p>
        </div>
      )}
      <Spin spinning={isLoading}>
        <div className="rounded-md bg-white px-2 py-3">
          <form id="bulk-menu-upload-form" onSubmit={uploadFile}>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                <div className="flex items-center bg-gray-200 py-2 px-4 rounded cursor-pointer">
                  <CloudUploadOutlined className="mx-2" />
                  <div className="flex-grow truncate">
                    {file ? file.name : t("Select excel file")}
                  </div>
                </div>

                <input
                  ref={fileInputRef}
                  type="file"
                  style={{ display: "none" }}
                  name="file"
                  id="file"
                  lang="ar"
                  accept=".xlsx, .xls"
                  className="hidden"
                  onChange={(e) => {
                    setFile(e.target.files[0]);
                    setError(null);
                  }}
                />
              </label>
            </div>
          </form>
        </div>
      </Spin>
    </AppModal>
  );
}

export default BulkMenu;
